import { render, staticRenderFns } from "./TeXinQiYe.vue?vue&type=template&id=58f4addb&"
import script from "./TeXinQiYe.vue?vue&type=script&lang=js&"
export * from "./TeXinQiYe.vue?vue&type=script&lang=js&"
import style0 from "./TeXinQiYe.vue?vue&type=style&index=0&id=58f4addb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports